import { render, staticRenderFns } from "./BranchCheckersQueueTable.vue?vue&type=template&id=b43e80e8&scoped=true&"
import script from "./BranchCheckersQueueTable.vue?vue&type=script&lang=js&"
export * from "./BranchCheckersQueueTable.vue?vue&type=script&lang=js&"
import style0 from "./BranchCheckersQueueTable.vue?vue&type=style&index=0&id=b43e80e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43e80e8",
  null
  
)

export default component.exports